import { BANK_DETAILS, CHECKOUT, PAY_NOW } from "../action/checkout";
import { BankDetailsData } from "../../datamodels/BankDetailsData";

const initialState = {
  bankDetails: new BankDetailsData(),
};

const CheckoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHECKOUT: {
      return {
        ...state,
      };
    }

    case BANK_DETAILS: {
      const { payload } = action;
      return {
        ...state,
        bankDetails: new BankDetailsData(
          payload.id,
          payload.bank_name,
          payload.bank_account,
          payload.bank_account_holder_name,
          payload.branch_name,
          payload.ifsc_code,
          payload.qr_code_image
        ),
      };
    }

    case PAY_NOW: {
      return {
        ...state,
      };
    }

    default:
      return state;
  }
};

export default CheckoutReducer;
